import { render } from "./Field.vue?vue&type=template&id=3c20e6fd&scoped=true"
import script from "./Field.vue?vue&type=script&lang=js"
export * from "./Field.vue?vue&type=script&lang=js"

import "./Field.vue?vue&type=style&index=0&id=3c20e6fd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c20e6fd"

export default script